// Mapa das páginas da Berta (dados puros, sem componentes): usado pelo menu
// (layouts/ExtendedSidebarLayout/.../items.js) e pelas rotas (./routes.js).
//
// Rotas montadas UMA vez em src/router/index.js como "berta/*" dentro de
// /extended-sidebar. Cada página é protegida pela chave de plano `berta` e pela
// permissão granular do submódulo (afiliados).

export const BERTA_BASE = "/extended-sidebar/berta";

// Itens do menu lateral, na ordem em que aparecem.
export const BERTA_MENU = [
  { name: "Início", path: "inicio", permissionKey: "berta", monitorType: "AcessoBertaInicio" },
  { name: "Pauta", path: "pauta", permissionKey: "berta_pauta", monitorType: "AcessoBertaPauta" },
  { name: "Fontes", path: "fontes", permissionKey: "berta_fontes", monitorType: "AcessoBertaFontes" },
  { name: "Espelho", path: "espelho", permissionKey: "berta_espelho", monitorType: "AcessoBertaEspelho" },
  { name: "Laudas", path: "laudas", permissionKey: "berta_laudas", monitorType: "AcessoBertaLaudas" },
  { name: "Brutos", path: "brutos", permissionKey: "berta_brutos", monitorType: "AcessoBertaBrutos" },
  { name: "Teleprompter", path: "teleprompter", permissionKey: "berta_tp", monitorType: "AcessoBertaTeleprompter" },
  { name: "Configurações", path: "configuracoes", permissionKey: "berta", monitorType: "AcessoBertaConfiguracoes" },
];

export const bertaLink = (path = "") => (path ? `${BERTA_BASE}/${path}` : BERTA_BASE);
